
export default {
    grid: {
        // MUST match values in grid.scss
        gutter: 0.02, // vw, as a percent
        outergutter: 0.02, // vw, as a percent
        rowspace: '3rem'
    },

    breakpoints: {
        // MUST match values in responsive.scss
        phoneMax: 767,
        tabletMax: 1150
    },

    anim: {
        // match values in animation.scss
        transitionSpeed: 800,
        hoverSpeed: 300,
        easing: 'easeInOutQuad'
    },

    classes: {
        state: {
            arranging: 'state--arranging',
            active: 'state--active',
            sticky: 'state--sticky',
            bottom: 'state--bottom',
            loaded: 'state--loaded',
            hidden: 'state--hidden',
            noanimate: 'state--noanimate',
            loading: 'state--loading'
        }
    }
};
